import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import GlobalStyle from "./theme/globalStyles";
import { ThemeProvider } from "styled-components";
import theme from "./theme/theme";
import CreateAccount from "./pages/CreateAccount";
import Login from "./pages/Login";
import AdvisorLogin from "./pages/AdvisorLogin";
import ChangeDefaultPassword from "./pages/ChangeDefaultPassword";
import ForgotPassword from "./pages/ForgotPassword";
import AccountDetails from "./pages/AccountDetails";
import EmailVerification from "./pages/EmailVerification";
import TermsofServices from "./pages/TermsofServices";
import MyGoal from "./pages/MyGoal";
import Dashboard from "./pages/Dashboard";
import NonAccess from "./pages/NonAscess";
import QuestionnaireSteps from "./pages/QuestionnaireSteps";
import GoalPicker from "./pages/GoalPicker";
import { Switch, Route, Redirect } from "react-router-dom";
import "./App.css";
import CookieConsentPopUp from "./components/CookieConsentPopUp";
import { getAccessToken } from "./redux/cookie";
import SelectCustodian from "./pages/SelectCustodian";
import SelectCustodianType from "./pages/SelectCustodianType";
import ChoseCustodian from "./pages/ChoseCustodian";
import NewDashboard from "./pages/NewDashboard";
import IndividualForm from "./pages/IndividualForm";
import ReviewIndividualForm from "./pages/ReviewIndividualForm";
import VerificationForm from "./pages/VerificationForm";
import RiaForm from "./pages/RiaForm";
import ReviewRiaForm from "./pages/ReviewRiaForm";
import ReviewJointForm from "./pages/ReviewJointForm";
import VerificationRiaForm from "./pages/VerificationRiaForm";
import JointForm from "./pages/JointForm";
import VerificationJointForm from "./pages/VerificationJointForm";
import AdvisorAgreement from "./pages/AdvisorAgreement";
import NewEmailVerification from "./pages/NewEmailVerification";
import TimeoutModal from "./components/TimeoutModal/TimeoutModal";
import MultifactorAuthentication from "./pages/MultiFactorAuthentication";
import Documents from "./pages/Documents";
import AdvisorPortalLanding from "./pages/AdvisorPortalLanding";
import AdvisorPortalAccountManagement from "./pages/AdvisorPortalAccountManagement";
import AdvisorPortalUsersUnderMyFirm from "./pages/AdvisorPortalUsersUnderMyFirm";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { SET_LOADING } from "./redux/action-types";
import TemporaryPassword from "./pages/TemporaryPassword";
import AdvisorMarketplace from "./pages/MarketPlace/AdvisorMarketplace";

let evenFired = 0;
let timeOutId;

function App() {
  const user = useSelector((state) => state.user);
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isForceUpdate, setForceUpdate] = useState(false);
  const [triggerTimeoutCount, setTriggerTimeoutCount] = useState(0);
  const [eventFiredState, setEventFiredState] = useState(0);
  const [isTimeOutModalVisible, setIsTimeOutModalVisible] = useState(false);

  useEffect(() => {
    if (
      user?.userAccountDetails?.firstName &&
      user?.userAccountDetails?.isAggreWithTermsAndServices &&
      !user?.userAccountDetails?.submissionDataId &&
      (location.pathname !== "/" ||
        location.pathname !== "/login" ||
        location.pathname !== "/multi-factor-authentication" ||
        location.pathname !== "/account-details" ||
        location.pathname !== "/terms-of-services" ||
        location.pathname !== "/advisor-agreement")
    ) {
      dispatch({ type: SET_LOADING, payload: false });
      history.push("/advisor-agreement");
    }
  }, [dispatch, history, location.pathname, user?.userAccountDetails]);

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      evenFired++;
      setEventFiredState(evenFired);
      clearTimeout(timeOutId);
    });

    document.addEventListener("click", function (event) {
      evenFired++;
      setEventFiredState(evenFired);
      clearTimeout(timeOutId);
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (evenFired > 0) setTriggerTimeoutCount(triggerTimeoutCount + 1);
    }, 500);
  }, [eventFiredState]);

  useEffect(() => {
    timeOutId = setTimeout(() => {
      if (getAccessToken()) setIsTimeOutModalVisible(true);
    }, 1000 * 60 * 20);
  }, [triggerTimeoutCount]);

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        {!localStorage.getItem("cookieConsent") && (
          <CookieConsentPopUp
            buttonClick={() => setForceUpdate(!isForceUpdate)}
          />
        )}
        {isTimeOutModalVisible && (
          <TimeoutModal setIsTimeOutModalVisible={setIsTimeOutModalVisible} />
        )}
        <Switch>
          <Route exact path="/goal-picker">
            <GoalPicker />
          </Route>
          <Route
            path={[
              "/build_wealth",
              "/major_purchase",
              "/education",
              "/retirement",
            ]}
            component={getAccessToken() ? QuestionnaireSteps : NonAccess}
          >
            {!user.hasGoal && <Redirect to="/strategy-screen" />}
          </Route>
          <Route path="/dashboard">
            {getAccessToken() ? <Dashboard /> : <NonAccess />}
            {/* {!user.hasGoal && <Redirect to="/" />} */}
          </Route>
          <Route exact path="/login/:isPasswordChanged?">
            <Login />
          </Route>
          <Route exact path="/advisor/login">
            <AdvisorLogin />
          </Route>
          <Route exact path="/change-default-password">
            <ChangeDefaultPassword />
          </Route>
          <Route exact path="/individual-form">
            {getAccessToken() ? <IndividualForm /> : <NonAccess />}
          </Route>
          <Route exact path="/multi-factor-authentication">
            {<MultifactorAuthentication />}
          </Route>
          <Route exact path="/joint-form">
            {getAccessToken() ? <JointForm /> : <NonAccess />}
          </Route>
          <Route exact path="/review-individual-form">
            {getAccessToken() ? <ReviewIndividualForm /> : <NonAccess />}
          </Route>
          <Route exact path="/review-ria-form">
            {getAccessToken() ? <ReviewRiaForm /> : <NonAccess />}
          </Route>
          <Route exact path="/review-joint-form">
            {getAccessToken() ? <ReviewJointForm /> : <NonAccess />}
          </Route>
          <Route exact path="/ria-verification-form">
            {getAccessToken() ? <VerificationRiaForm /> : <NonAccess />}
          </Route>
          <Route exact path="/verification-form/:type">
            {getAccessToken() ? <VerificationForm /> : <NonAccess />}
          </Route>
          <Route exact path="/temporary-password">
            {getAccessToken() ? <TemporaryPassword /> : <NonAccess />}
          </Route>
          <Route exact path="/document">
            {getAccessToken() ? <Documents /> : <NonAccess />}
          </Route>
          <Route exact path="/joint-verification-form">
            {getAccessToken() ? <VerificationJointForm /> : <NonAccess />}
          </Route>
          <Route exact path="/ria-form">
            {getAccessToken() ? <RiaForm /> : <NonAccess />}
          </Route>
          <Route exact path="/forgot-password">
            <ForgotPassword />
          </Route>
          <Route exact path="/select-custodian">
            {getAccessToken() ? <SelectCustodian /> : <NonAccess />}
          </Route>
          <Route exact path="/choose-custodian">
            {getAccessToken() ? <ChoseCustodian /> : <NonAccess />}
          </Route>
          <Route exact path="/select-custodian-type">
            {getAccessToken() ? <SelectCustodianType /> : <NonAccess />}
          </Route>
          <Route exact path="/">
            <Login />
          </Route>
          <Route exact path="/signup">
            <CreateAccount />
          </Route>
          <Route exact path="/strategy-screen/:from?">
            {getAccessToken() ? <NewDashboard /> : <NonAccess />}
          </Route>
          <Route exact path="/mail-verification/:mailId/:isFromModal?">
            <EmailVerification />
          </Route>
          <Route exact path="/new-mail-verification">
            <NewEmailVerification />
          </Route>
          <Route exact path="/account-details">
            {getAccessToken() ? <AccountDetails /> : <NonAccess />}
          </Route>
          <Route exact path="/terms-of-services">
            {getAccessToken() ? <TermsofServices /> : <NonAccess />}
          </Route>
          <Route exact path="/my-goal/:from?">
            {getAccessToken() ? <MyGoal /> : <NonAccess />}
          </Route>
          <Route exact path="/advisor-agreement">
            {getAccessToken() ? <AdvisorAgreement /> : <NonAccess />}
          </Route>
          <Route exact path="/advisor-portal-landing">
            {getAccessToken() ? <AdvisorPortalLanding /> : <NonAccess />}
          </Route>
          <Route exact path="/advisor-portal-account-management/:defaultTab?">
            {getAccessToken() ? (
              <AdvisorPortalAccountManagement />
            ) : (
              <NonAccess />
            )}
          </Route>
          <Route exact path="/advisor-portal-users-under-my-farm">
            {getAccessToken() ? (
              <AdvisorPortalUsersUnderMyFirm />
            ) : (
              <NonAccess />
            )}
          </Route>
          <Route exact path="/marketplace-dashboard">
            {getAccessToken() ? <AdvisorMarketplace /> : <NonAccess />}
          </Route>
        </Switch>
      </ThemeProvider>
    </div>
  );
}

export default App;
